import { commonFilter } from './filter';

export default {
  pageName: 'MarketPopularityRanking',
  pageId: '25041',
  pagePath: '/opinion/Overview/MarketPopularityRanking',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    SwitchGameType: {
      buttonId: '25041001',
    },
    SwitchChannelType: {
      buttonId: '25041002',
    },
    SearchGame: {
      buttonId: '25041003',
    },
    Download: {
      buttonId: '25041004',
    },
    SelectedItem: {
      buttonId: '25041005',
    },
    SwitchTrendMetrics: {
      buttonId: '25041006',
    },
    OpenGameDetail: {
      buttonId: '25041007',
    },
    GotoGamePage: {
      buttonId: '25041008',
    },
    SwitchPublicationHashtag: {
      buttonId: '25041009',
    },
    GotoTop50Post: {
      buttonId: '25041010',
    },
    ClickPost: {
      buttonId: '25041011',
    },
    GotoTop50Hashtag: {
      buttonId: '25041012',
    },
    SearchHashtag: {
      buttonId: '25041013',
    },
    ClickHashtag: {
      buttonId: '25041014',
    },

    GPT_Get_Btn: {
      buttonId: '25041020',
    },
    GPT_Stop: {
      buttonId: '25041021',
    },
    GPT_Type: {
      buttonId: '25041022',
    },
    GPT_Confirm: {
      buttonId: '25041023',
    },
    GPT_Agent: {
      buttonId: '25041024',
    },

    ...commonFilter,
  },
  card: {},
};
